import React , {useRef} from "react";
import { Link } from "react-router-dom";
import Marquee from "react-fast-marquee";
import { gsap } from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger, SplitText } from "gsap/all";
gsap.registerPlugin(ScrollTrigger, SplitText);
const AboutOne = () => {
  const container = useRef();
  useGSAP(
    () => {

      // let split = SplitText.create(".content_para_animation", {
      //   type: "words,chars,lines",
      // });

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: container.current,
          start: "top+=250 bottom",
          end: "bottom",
          // markers: true
        },
      });
      
       tl.fromTo(
          ".about_heading_animation",
          { opacity: 0, y: 60 },
          {
            opacity: 1,
            y: 0,
            duration: 0.8,
            stagger: 0.1,
            // ease: 'power3.out',
            // stagger: 0.4 // Adjust this value for the desired stagger effect
          }
        ).fromTo(
          ".about__image_animation",
          { opacity: 0, y: 80 },
          {
            opacity: 1,
            y: 0,
            duration: 0.8,
            
            // ease: 'power3.out',
            // stagger: 0.4 // Adjust this value for the desired stagger effect
          }, "0"
        )
      return () => {
        tl.kill();
      };
    },
    { scope: container },
  );
  return (
    <div className="about-area-1 position-relative space-top" ref={container}>
      <div className="about1-shape-img1 about__image_animation">
        <img
          className="about1-shape-img-1"
          src="/assets/img/normal/about_shape1-1.png"
          alt="img"
        />
      </div>
      <div className="about1-shape-img2">
        <img
          className="about1-shape-img-2"
          src="/assets/img/normal/about_shape1-2.png"
          alt="img"
        />
      </div>
      <div className="container">
        <div className="row gx-60 align-items-center">
          <div className="col-xl-6">
            <div className="about-content-wrap">
              <div className="title-area me-xl-5 mb-20">
                <span className="sub-title about_heading_animation">
                  <img src="/assets/img/icon/title_left.svg" alt="shape" />
                  About Us
                </span>
                <h2 className="sec-title about_heading_animation">
                  Cloud & Managed Services for Your Business
                </h2>
                <p className="sec-text mb-35 about_heading_animation">
                  It’s time for you to catch up with cloud trends and leverage
                  on-demand services to boost business productivity and
                  scalability. Modernize your IT infrastructure with
                  market-leading solutions to enhance operational efficiency
                  through our managed services.
                </p>
                <p className="sec-text mb-35 about_heading_animation">
                  Our experts ensure seamless cloud adoption, improved security,
                  and optimized performance. With scalable solutions and
                  continuous support, we help your business stay agile, reduce
                  costs, and focus on innovation while we manage your IT
                  complexity.
                </p>
              </div>
              {/* <div className="achive-about">
                <div className="achive-about_content">
                  <div className="achive-about_icon">
                    <i className="fas fa-check" />
                  </div>
                  <div className="media-body">
                    <h3 className="box-title">Strategic Solutions Pro</h3>
                    <p className="achive-about_text">
                      There are many variati of passages of engineer's
                      available. The majority have suffered alteration in
                      engineer's available.
                    </p>
                  </div>
                </div>
              </div> */}
              {/* <div className="achive-about">
                <div className="achive-about_content">
                  <div className="achive-about_icon">
                    <i className="fas fa-check" />
                  </div>
                  <div className="media-body">
                    <h3 className="box-title">
                      Performance Enhancement Partners
                    </h3>
                    <p className="achive-about_text">
                      There are many variati of passages of engineer's
                      available. The majority have suffered alteration in
                      engineer's available.
                    </p>
                  </div>
                </div>
              </div> */}
              <div className=" btn-wrap mt-20 ">
                <Link to="/about" className="global-btn mt-xl-0 mt-20 about_heading_animation">
                  Read More <i className="fas fa-arrow-right ms-2" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
        <div className="client-bg-area-2">
          <div className="client-area-2">
            <div className=" global-carousel">
              <Marquee speed={30}>
                <div>
                  <div className="client-logo">

                    <img src="assets/img/client/p-1.svg" alt="img" height={50} width={180}/>

                  </div>
                </div>
                <div>
                  <div className="client-logo">

                                       <img src="assets/img/client/p-2.svg" alt="img" height={50} width={180}/>


                  </div>
                </div>
                <div>
                  <div className="client-logo">

                                       <img src="assets/img/client/p-3.svg" alt="img" height={50} width={180}/>


                  </div>
                </div>
                <div>
                  <div className="client-logo">

                                      <img src="assets/img/client/p-4.svg" alt="img" height={50} width={180}/>

                  </div>
                </div>
                <div>
                  <div className="client-logo">

                                        <img src="assets/img/client/p-5.svg" alt="img" height={50} width={180}/>


                  </div>
                </div>
                <div>
                  <div className="client-logo">

                                       <img src="assets/img/client/p-6.svg" alt="img" height={50} width={180}/>


                  </div>
                </div>
                <div>
                  <div className="client-logo">

                                      <img src="assets/img/client/p-7.svg" alt="img" height={50} width={180}/>


                  </div> 
                  </div>
                  <div>
                   <div className="client-logo">

                                      <img src="assets/img/client/p-8.svg" alt="img" height={50} width={180}/>


                  </div>
                </div>
             
              </Marquee>
            </div>
          </div>
        </div>
    </div>
  );
};

export default AboutOne;
